// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".google-reviews[data-v-8612d292]{width:100%;padding:40px 10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
